export default __webpack_public_path__ + "static/media/Boots of the Black Pharaoh.1453f645.jpg";